import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { RecordTimeProvider } from "@/components/RecordTimeModal";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Matters from "@/pages/Matters";
import MatterDetail from "@/pages/MatterDetail";
import Leads from "@/pages/Leads";
import CourtLog from "@/pages/CourtLog";
import Schedule from "@/pages/Schedule";
import Invoices from "@/pages/Invoices";
import InvoiceDetail from "@/pages/InvoiceDetail";
import Settings from "@/pages/Settings";
import SignAgreement from "@/pages/SignAgreement";
import Trust from "@/pages/Trust";
import DocumentCentre from "@/pages/DocumentCentre";
import ClientPortal from "@/pages/ClientPortal";
import PortalPaymentSuccess from "@/pages/PortalPaymentSuccess";
import Workload from "@/pages/Workload";
import Onboarding from "@/pages/Onboarding";
import PlatformConsole, { PlatformLogin } from "@/pages/Platform";
import PlatformFirm from "@/pages/PlatformFirm";

function Protected({ children, roles }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-slate-400 font-serif text-xl">Loading LegalOS…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/clients" replace />;
  return children;
}

function Shell() {
  return (
    <Protected>
      <RecordTimeProvider><Layout /></RecordTimeProvider>
    </Protected>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/platform/login" element={<PlatformLogin />} />
            <Route path="/owner" element={<PlatformLogin />} />
            <Route path="/superadmin" element={<PlatformLogin />} />
            <Route path="/platform" element={<PlatformConsole />} />
            <Route path="/platform/firms/:slug" element={<PlatformFirm />} />
            <Route path="/sign/:token" element={<SignAgreement />} />
            <Route path="/portal/:token" element={<ClientPortal />} />
            <Route path="/portal/:token/payment/success" element={<PortalPaymentSuccess />} />
            <Route element={<Shell />}>
              <Route path="/" element={<Protected roles={["admin", "lawyer"]}><Dashboard /></Protected>} />
              <Route path="/clients" element={<Clients />} />
              <Route path="/clients/:id" element={<ClientDetail />} />
              <Route path="/matters" element={<Matters />} />
              <Route path="/matters/:id" element={<MatterDetail />} />
              <Route path="/leads" element={<Leads />} />
              <Route path="/court-log" element={<CourtLog />} />
              <Route path="/schedule" element={<Schedule />} />
              <Route path="/invoices" element={<Protected roles={["admin", "lawyer"]}><Invoices /></Protected>} />
              <Route path="/invoices/:id" element={<Protected roles={["admin", "lawyer"]}><InvoiceDetail /></Protected>} />
              <Route path="/settings" element={<Protected roles={["admin"]}><Settings /></Protected>} />
              <Route path="/trust" element={<Protected roles={["admin", "lawyer"]}><Trust /></Protected>} />
              <Route path="/documents" element={<Protected roles={["admin"]}><DocumentCentre /></Protected>} />
              <Route path="/workload" element={<Protected roles={["admin"]}><Workload /></Protected>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors theme="dark" />
      </AuthProvider>
    </div>
  );
}
